module.exports = __webpack_public_path__ + "static/media/Logo.e08b79eb.png";